/*
 * Shared "add to cart" behaviour for product cards (homepage + collection grids).
 * Kept in one asset rather than duplicated into each section's inline <script>,
 * so the cart-add and header-count logic only exists in one place.
 */
(function () {
  'use strict';

  // Refresh the header bag count after a successful add, so it doesn't sit stale
  // until the next full page load. The badge is always rendered (hidden at zero)
  // so there is an element to update here.
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var el = document.getElementById('db-cart-count');
        if (!el) return;
        el.textContent = cart.item_count;
        if (cart.item_count > 0) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      })
      .catch(function () { /* count is cosmetic — never block the add on it */ });
  }

  // ---- Cart drawer -------------------------------------------------------
  // The drawer's markup lives in sections/db-cart-drawer.liquid. After any cart
  // mutation we re-request just that section and swap it in, so the HTML is only
  // ever authored in Liquid.

  function setDrawerOpen(open) {
    var drawer = document.getElementById('db-cd');
    var overlay = document.getElementById('db-cd-overlay');
    if (!drawer || !overlay) return;
    drawer.classList.toggle('open', open);
    overlay.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }

  window.dbOpenCartDrawer = function () { setDrawerOpen(true); };
  window.dbCloseCartDrawer = function () { setDrawerOpen(false); };

  // Re-render the drawer from the server. `keepOpen` preserves the open state
  // across the swap, since replacing the node drops the .open class with it.
  function refreshCartDrawer(keepOpen) {
    return fetch('/?sections=db-cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data['db-cart-drawer'];
        var current = document.getElementById('shopify-section-db-cart-drawer');
        if (!html || !current) return;
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var fresh = holder.querySelector('#shopify-section-db-cart-drawer') || holder.firstElementChild;
        current.replaceWith(fresh);
        if (keepOpen) setDrawerOpen(true);
      })
      .catch(function () { /* leave the stale drawer rather than blanking it */ });
  }
  window.dbRefreshCartDrawer = refreshCartDrawer;

  // line is the 1-based cart line index; quantity 0 removes the line.
  window.dbCartChange = function (line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not update cart.');
        return res.json();
      })
      .then(function () {
        refreshCartCount();
        return refreshCartDrawer(true);
      })
      .catch(function (err) { alert(err.message || 'Could not update the cart.'); });
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawerOpen(false);
  });

  window.dbAddToCart = function (btn, variantId) {
    if (btn.dataset.busy === '1') return;

    // Swap the label span, not the button's textContent — the latter would delete
    // the inline icon SVG.
    var label = btn.querySelector('.db-atc-label') || btn;
    var original = label.textContent;

    btn.dataset.busy = '1';
    btn.disabled = true;
    label.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || err.message || 'Could not add to cart.');
          });
        }
        return res.json();
      })
      .then(function () {
        label.textContent = 'Added ✓';
        refreshCartCount();
        // Show the drawer so the customer gets immediate confirmation of what
        // went in, without leaving the page they were browsing.
        refreshCartDrawer(true);
        setTimeout(function () {
          label.textContent = original;
          btn.disabled = false;
          btn.dataset.busy = '0';
        }, 1600);
      })
      .catch(function (err) {
        label.textContent = original;
        btn.disabled = false;
        btn.dataset.busy = '0';
        alert(err.message || 'Something went wrong. Please try again.');
      });
  };
})();
